import { createContext, useMemo, useState } from "react";
import { VideoWallConfig } from "../mock/video-wall";

interface VideoWallContextValue {
  videoWallConfig: VideoWallConfig | null;
  setVideoWallConfig: (artifactThemes: VideoWallConfig) => void;
}

export const VideoWallContext = createContext<VideoWallContextValue>(
  {} as VideoWallContextValue
);

export const VideoWallProvider: React.FC = ({ children }) => {
  const [videoWallConfig, setVideoWallConfig] =
    useState<VideoWallConfig | null>(null);

  const value = useMemo(
    () => ({ videoWallConfig, setVideoWallConfig }),
    [videoWallConfig]
  );

  return (
    <VideoWallContext.Provider value={value}>
      {children}
    </VideoWallContext.Provider>
  );
};
